import { selectPeriod, fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import { PillTypes, Resources, exportKey } from '../constants';

import {
  fetchConfigurationCompanyCodes as fetchConfigurationCompanyCodesApi,
  fetchConfigurationBusinessUnits as fetchConfigurationBusinessUnitsApi,
  fetchConfigurationLegalEntities as fetchConfigurationLegalEntitiesApi,
  fetchConfigurationTaxRates as fetchConfigurationTaxRatesApi,
  fetchConfigurationBookToTaxDifferences as fetchConfigurationBookToTaxDifferencesApi,
  fetchConfigurationObligations as fetchConfigurationObligationsApi,
  fetchConfigurationTLSAccounts as fetchConfigurationTLSAccountsApi,
  fetchConfigurationTaxAccounting as fetchConfigurationTaxAccountingApi,
  fetchConfigurationUsers as fetchConfigurationUsersApi,
  fetchConfigurationGlJournals as fetchConfigurationGlJournalsApi,
  fetchConfigurationCurrencies as fetchConfigurationCurrenciesApi,
  fetchConfigurationTaxBookingEntities as fetchConfigurationTaxBookingEntitiesApi,
  fetchConfigurationPeriods as fetchConfigurationPeriodsApi,
  fetchConfigurationCurrencyConversionRates as fetchConfigurationCurrencyConversionRatesApi,
} from '../api';

import {
  FETCH_CONFIGURATION_SETTINGS_PILL,
  FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS,
  FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE,
  FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT,
  FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE,
} from './types';

const pillTypesToApiCalls = {
  COMPANY_CODES: fetchConfigurationCompanyCodesApi,
  BUSINESS_UNITS: fetchConfigurationBusinessUnitsApi,
  LEGAL_ENTITIES: fetchConfigurationLegalEntitiesApi,
  TAX_RATES: fetchConfigurationTaxRatesApi,
  BOOK_TO_TAX_DIFFERENCES: fetchConfigurationBookToTaxDifferencesApi,
  OBLIGATIONS: fetchConfigurationObligationsApi,
  TAX_BOOKING_ENTITIES: fetchConfigurationTaxBookingEntitiesApi,
  TLS_ACCOUNTS: fetchConfigurationTLSAccountsApi,
  TAX_ACCOUNTING: fetchConfigurationTaxAccountingApi,
  USERS: fetchConfigurationUsersApi,
  SUBLEDGER_MAP: fetchConfigurationGlJournalsApi,
  CURRENCY: fetchConfigurationCurrenciesApi,
  PERIODS: fetchConfigurationPeriodsApi,
  CURRENCY_CONVERSION_RATES: fetchConfigurationCurrencyConversionRatesApi,
};

export const fetchConfigurationSettingsAllPills = (periodName, callback) => async dispatch => {
  const pillTypes = Object.keys(PillTypes);
  const fieldToLoad = pillTypes.concat(exportKey);

  const dispatchSuccessAction = ({ pillType, reportData }) => dispatch({
    type: FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS,
    pillType,
    [Resources[pillType]]: reportData,
  });

  dispatch({
    type: FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT,
    loading: fieldToLoad.reduce((result, pillType) => {
      result[Resources[pillType]] = true;
      return result;
    }, {}),
  });

  const configurationSettings = {};

  for (let index = 0; index < pillTypes.length; index++) {
    const pillType = pillTypes[index];
    try {
      const apiCall = pillTypesToApiCalls[pillType];
      const reportData = await apiCall(periodName);
      configurationSettings[Resources[pillType]] = reportData;

      dispatchSuccessAction({ pillType, reportData });
    } catch (error) {
      if (error.isFetchingError) {
        dispatch(fetchingError());
        dispatch(errorNotification(error.message));
        return dispatch({
          type: FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE,
          loading: pillTypes.reduce((result, pillType) => {
            result[Resources[pillType]] = false;
            return result;
          }, {}),
        });
      }
    }
  }

  setTimeout(() =>
    callback({ configurationSettings, periodName, callback: () =>
      dispatchSuccessAction({ pillType: exportKey, reportData: null }),
    }),
  1000); // It needs to be 1 second so that the progress has enough time to render before exporting will freeze the whole application
};

export const fetchConfigurationSettingsPill = (pillType, periodName) => async dispatch => {
  dispatch({
    type: FETCH_CONFIGURATION_SETTINGS_PILL,
    pillType,
  });

  try {
    const apiCall = pillTypesToApiCalls[pillType];
    const reportData = await apiCall(periodName);

    return dispatch({
      type: FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS,
      pillType,
      [Resources[pillType]]: reportData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE,
        pillType,
      });
    }
  }
};

export const changePeriod = (activePill, period) => dispatch => {
  dispatch(selectPeriod(period));

  if (activePill !== PillTypes.COMPANY_CODES) {
    dispatch(fetchConfigurationSettingsPill(PillTypes.COMPANY_CODES, period.name));
  }

  dispatch(fetchConfigurationSettingsPill(activePill, period.name));
};
